import { render, staticRenderFns } from "./IF-AtısDest.vue?vue&type=template&id=6dc47ff7&scoped=true&"
import script from "./IF-AtısDest.vue?vue&type=script&lang=js&"
export * from "./IF-AtısDest.vue?vue&type=script&lang=js&"
import style0 from "./IF-AtısDest.vue?vue&type=style&index=0&id=6dc47ff7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc47ff7",
  null
  
)

export default component.exports